var zi = Object.defineProperty;
var Bi = (t, e) => {
    for (var r in e) zi(t, r, { get: e[r], enumerable: !0 });
};
var gr = {};

var dr = {
        activateTrap: function (e, r) {
            if (e.length > 0) {
                var i = e[e.length - 1];
                i !== r && i._setPausedState(!0);
            }
            var n = e.indexOf(r);
            n === -1 || e.splice(n, 1), e.push(r);
        },
        deactivateTrap: function (e, r) {
            var i = e.indexOf(r);
            i !== -1 && e.splice(i, 1),
                e.length > 0 && !e[e.length - 1]._isManuallyPaused() && e[e.length - 1]._setPausedState(!1);
        },
    },
    un = function (e) {
        return e.tagName && e.tagName.toLowerCase() === "input" && typeof e.select == "function";
    },
    pn = function (e) {
        return e?.key === "Escape" || e?.key === "Esc" || e?.keyCode === 27;
    },
    we = function (e) {
        return e?.key === "Tab" || e?.keyCode === 9;
    },
    mn = function (e) {
        return we(e) && !e.shiftKey;
    },
    dn = function (e) {
        return we(e) && e.shiftKey;
    },
    hr = function (e) {
        return setTimeout(e, 0);
    },
    xe = function (e) {
        for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++) i[n - 1] = arguments[n];
        return typeof e == "function" ? e.apply(void 0, i) : e;
    },
    Ue = function (e) {
        return e.target.shadowRoot && typeof e.composedPath == "function" ? e.composedPath()[0] : e.target;
    },
    hn = [],
    gn = function (e, r) {
        var i = r?.document || document,
            n = r?.trapStack || hn,
            s = mr(
                {
                    returnFocusOnDeactivate: !0,
                    escapeDeactivates: !0,
                    delayInitialFocus: !0,
                    isKeyForward: mn,
                    isKeyBackward: dn,
                },
                r
            ),
            o = {
                containers: [],
                containerGroups: [],
                tabbableGroups: [],
                nodeFocusedBeforeActivation: null,
                mostRecentlyFocusedNode: null,
                active: !1,
                paused: !1,
                manuallyPaused: !1,
                delayInitialFocusTimer: void 0,
                recentNavEvent: void 0,
            },
            a,
            l = function (f, p, h) {
                return f && f[p] !== void 0 ? f[p] : s[h || p];
            },
            c = function (f, p) {
                var h = typeof p?.composedPath == "function" ? p.composedPath() : void 0;
                return o.containerGroups.findIndex(function (S) {
                    var v = S.container,
                        w = S.tabbableNodes;
                    return (
                        v.contains(f) ||
                        h?.includes(v) ||
                        w.find(function (x) {
                            return x === f;
                        })
                    );
                });
            },
            m = function (f) {
                var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
                    h = p.hasFallback,
                    S = h === void 0 ? !1 : h,
                    v = p.params,
                    w = v === void 0 ? [] : v,
                    x = s[f];
                if ((typeof x == "function" && (x = x.apply(void 0, an(w))), x === !0 && (x = void 0), !x)) {
                    if (x === void 0 || x === !1) return x;
                    throw new Error("`".concat(f, "` was specified but was not a node, or did not return a node"));
                }
                var N = x;
                if (typeof x == "string") {
                    try {
                        N = i.querySelector(x);
                    } catch (C) {
                        throw new Error(
                            "`".concat(f, '` appears to be an invalid selector; error="').concat(C.message, '"')
                        );
                    }
                    if (!N && !S) throw new Error("`".concat(f, "` as selector refers to no known node"));
                }
                return N;
            },
            u = function () {
                var f = m("initialFocus", { hasFallback: !0 });
                if (f === !1) return !1;
                if (f === void 0 || (f && !qe(f, s.tabbableOptions)))
                    if (c(i.activeElement) >= 0) f = i.activeElement;
                    else {
                        var p = o.tabbableGroups[0],
                            h = p && p.firstTabbableNode;
                        f = h || m("fallbackFocus");
                    }
                else f === null && (f = m("fallbackFocus"));
                if (!f) throw new Error("Your focus-trap needs to have at least one focusable element");
                return f;
            },
            d = function () {
                if (
                    ((o.containerGroups = o.containers.map(function (f) {
                        var p = fr(f, s.tabbableOptions),
                            h = ur(f, s.tabbableOptions),
                            S = p.length > 0 ? p[0] : void 0,
                            v = p.length > 0 ? p[p.length - 1] : void 0,
                            w = h.find(function (C) {
                                return fe(C);
                            }),
                            x = h
                                .slice()
                                .reverse()
                                .find(function (C) {
                                    return fe(C);
                                }),
                            N = !!p.find(function (C) {
                                return re(C) > 0;
                            });
                        return {
                            container: f,
                            tabbableNodes: p,
                            focusableNodes: h,
                            posTabIndexesFound: N,
                            firstTabbableNode: S,
                            lastTabbableNode: v,
                            firstDomTabbableNode: w,
                            lastDomTabbableNode: x,
                            nextTabbableNode: function (U) {
                                var ee = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0,
                                    $ = p.indexOf(U);
                                return $ < 0
                                    ? ee
                                        ? h.slice(h.indexOf(U) + 1).find(function (j) {
                                              return fe(j);
                                          })
                                        : h
                                              .slice(0, h.indexOf(U))
                                              .reverse()
                                              .find(function (j) {
                                                  return fe(j);
                                              })
                                    : p[$ + (ee ? 1 : -1)];
                            },
                        };
                    })),
                    (o.tabbableGroups = o.containerGroups.filter(function (f) {
                        return f.tabbableNodes.length > 0;
                    })),
                    o.tabbableGroups.length <= 0 && !m("fallbackFocus"))
                )
                    throw new Error(
                        "Your focus-trap must have at least one container with at least one tabbable node in it at all times"
                    );
                if (
                    o.containerGroups.find(function (f) {
                        return f.posTabIndexesFound;
                    }) &&
                    o.containerGroups.length > 1
                )
                    throw new Error(
                        "At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps."
                    );
            },
            g = function (f) {
                var p = f.activeElement;
                if (p) return p.shadowRoot && p.shadowRoot.activeElement !== null ? g(p.shadowRoot) : p;
            },
            y = function (f) {
                if (f !== !1 && f !== g(document)) {
                    if (!f || !f.focus) {
                        y(u());
                        return;
                    }
                    f.focus({ preventScroll: !!s.preventScroll }), (o.mostRecentlyFocusedNode = f), un(f) && f.select();
                }
            },
            E = function (f) {
                var p = m("setReturnFocus", { params: [f] });
                return p || (p === !1 ? !1 : f);
            },
            A = function (f) {
                var p = f.target,
                    h = f.event,
                    S = f.isBackward,
                    v = S === void 0 ? !1 : S;
                (p = p || Ue(h)), d();
                var w = null;
                if (o.tabbableGroups.length > 0) {
                    var x = c(p, h),
                        N = x >= 0 ? o.containerGroups[x] : void 0;
                    if (x < 0)
                        v
                            ? (w = o.tabbableGroups[o.tabbableGroups.length - 1].lastTabbableNode)
                            : (w = o.tabbableGroups[0].firstTabbableNode);
                    else if (v) {
                        var C = o.tabbableGroups.findIndex(function (te) {
                            var X = te.firstTabbableNode;
                            return p === X;
                        });
                        if (
                            (C < 0 &&
                                (N.container === p ||
                                    (qe(p, s.tabbableOptions) &&
                                        !fe(p, s.tabbableOptions) &&
                                        !N.nextTabbableNode(p, !1))) &&
                                (C = x),
                            C >= 0)
                        ) {
                            var U = C === 0 ? o.tabbableGroups.length - 1 : C - 1,
                                ee = o.tabbableGroups[U];
                            w = re(p) >= 0 ? ee.lastTabbableNode : ee.lastDomTabbableNode;
                        } else we(h) || (w = N.nextTabbableNode(p, !1));
                    } else {
                        var $ = o.tabbableGroups.findIndex(function (te) {
                            var X = te.lastTabbableNode;
                            return p === X;
                        });
                        if (
                            ($ < 0 &&
                                (N.container === p ||
                                    (qe(p, s.tabbableOptions) &&
                                        !fe(p, s.tabbableOptions) &&
                                        !N.nextTabbableNode(p))) &&
                                ($ = x),
                            $ >= 0)
                        ) {
                            var j = $ === o.tabbableGroups.length - 1 ? 0 : $ + 1,
                                le = o.tabbableGroups[j];
                            w = re(p) >= 0 ? le.firstTabbableNode : le.firstDomTabbableNode;
                        } else we(h) || (w = N.nextTabbableNode(p));
                    }
                } else w = m("fallbackFocus");
                return w;
            },
            O = function (f) {
                var p = Ue(f);
                if (!(c(p, f) >= 0)) {
                    if (xe(s.clickOutsideDeactivates, f)) {
                        a.deactivate({ returnFocus: s.returnFocusOnDeactivate });
                        return;
                    }
                    xe(s.allowOutsideClick, f) || f.preventDefault();
                }
            },
            L = function (f) {
                var p = Ue(f),
                    h = c(p, f) >= 0;
                if (h || p instanceof Document) h && (o.mostRecentlyFocusedNode = p);
                else {
                    f.stopImmediatePropagation();
                    var S,
                        v = !0;
                    if (o.mostRecentlyFocusedNode)
                        if (re(o.mostRecentlyFocusedNode) > 0) {
                            var w = c(o.mostRecentlyFocusedNode),
                                x = o.containerGroups[w].tabbableNodes;
                            if (x.length > 0) {
                                var N = x.findIndex(function (C) {
                                    return C === o.mostRecentlyFocusedNode;
                                });
                                N >= 0 &&
                                    (s.isKeyForward(o.recentNavEvent)
                                        ? N + 1 < x.length && ((S = x[N + 1]), (v = !1))
                                        : N - 1 >= 0 && ((S = x[N - 1]), (v = !1)));
                            }
                        } else
                            o.containerGroups.some(function (C) {
                                return C.tabbableNodes.some(function (U) {
                                    return re(U) > 0;
                                });
                            }) || (v = !1);
                    else v = !1;
                    v && (S = A({ target: o.mostRecentlyFocusedNode, isBackward: s.isKeyBackward(o.recentNavEvent) })),
                        y(S || o.mostRecentlyFocusedNode || u());
                }
                o.recentNavEvent = void 0;
            },
            F = function (f) {
                var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                o.recentNavEvent = f;
                var h = A({ event: f, isBackward: p });
                h && (we(f) && f.preventDefault(), y(h));
            },
            I = function (f) {
                (s.isKeyForward(f) || s.isKeyBackward(f)) && F(f, s.isKeyBackward(f));
            },
            b = function (f) {
                pn(f) && xe(s.escapeDeactivates, f) !== !1 && (f.preventDefault(), a.deactivate());
            },
            D = function (f) {
                var p = Ue(f);
                c(p, f) >= 0 ||
                    xe(s.clickOutsideDeactivates, f) ||
                    xe(s.allowOutsideClick, f) ||
                    (f.preventDefault(), f.stopImmediatePropagation());
            },
            R = function () {
                if (o.active)
                    return (
                        dr.activateTrap(n, a),
                        (o.delayInitialFocusTimer = s.delayInitialFocus
                            ? hr(function () {
                                  y(u());
                              })
                            : y(u())),
                        i.addEventListener("focusin", L, !0),
                        i.addEventListener("mousedown", O, { capture: !0, passive: !1 }),
                        i.addEventListener("touchstart", O, { capture: !0, passive: !1 }),
                        i.addEventListener("click", D, { capture: !0, passive: !1 }),
                        i.addEventListener("keydown", I, { capture: !0, passive: !1 }),
                        i.addEventListener("keydown", b),
                        a
                    );
            },
            P = function () {
                if (o.active)
                    return (
                        i.removeEventListener("focusin", L, !0),
                        i.removeEventListener("mousedown", O, !0),
                        i.removeEventListener("touchstart", O, !0),
                        i.removeEventListener("click", D, !0),
                        i.removeEventListener("keydown", I, !0),
                        i.removeEventListener("keydown", b),
                        a
                    );
            },
            k = function (f) {
                var p = f.some(function (h) {
                    var S = Array.from(h.removedNodes);
                    return S.some(function (v) {
                        return v === o.mostRecentlyFocusedNode;
                    });
                });
                p && y(u());
            },
            ae = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(k) : void 0,
            _ = function () {
                ae &&
                    (ae.disconnect(),
                    o.active &&
                        !o.paused &&
                        o.containers.map(function (f) {
                            ae.observe(f, { subtree: !0, childList: !0 });
                        }));
            };
        return (
            (a = {
                get active() {
                    return o.active;
                },
                get paused() {
                    return o.paused;
                },
                activate: function (f) {
                    if (o.active) return this;
                    var p = l(f, "onActivate"),
                        h = l(f, "onPostActivate"),
                        S = l(f, "checkCanFocusTrap");
                    S || d(), (o.active = !0), (o.paused = !1), (o.nodeFocusedBeforeActivation = g(i)), p?.();
                    var v = function () {
                        S && d(), R(), _(), h?.();
                    };
                    return S ? (S(o.containers.concat()).then(v, v), this) : (v(), this);
                },
                deactivate: function (f) {
                    if (!o.active) return this;
                    var p = mr(
                        {
                            onDeactivate: s.onDeactivate,
                            onPostDeactivate: s.onPostDeactivate,
                            checkCanReturnFocus: s.checkCanReturnFocus,
                        },
                        f
                    );
                    clearTimeout(o.delayInitialFocusTimer),
                        (o.delayInitialFocusTimer = void 0),
                        P(),
                        (o.active = !1),
                        (o.paused = !1),
                        _(),
                        dr.deactivateTrap(n, a);
                    var h = l(p, "onDeactivate"),
                        S = l(p, "onPostDeactivate"),
                        v = l(p, "checkCanReturnFocus"),
                        w = l(p, "returnFocus", "returnFocusOnDeactivate");
                    h?.();
                    var x = function () {
                        hr(function () {
                            w && y(E(o.nodeFocusedBeforeActivation)), S?.();
                        });
                    };
                    return w && v ? (v(E(o.nodeFocusedBeforeActivation)).then(x, x), this) : (x(), this);
                },
                pause: function (f) {
                    return o.active ? ((o.manuallyPaused = !0), this._setPausedState(!0, f)) : this;
                },
                unpause: function (f) {
                    return o.active
                        ? ((o.manuallyPaused = !1), n[n.length - 1] !== this ? this : this._setPausedState(!1, f))
                        : this;
                },
                updateContainerElements: function (f) {
                    var p = [].concat(f).filter(Boolean);
                    return (
                        (o.containers = p.map(function (h) {
                            return typeof h == "string" ? i.querySelector(h) : h;
                        })),
                        o.active && d(),
                        _(),
                        this
                    );
                },
            }),
            Object.defineProperties(a, {
                _isManuallyPaused: {
                    value: function () {
                        return o.manuallyPaused;
                    },
                },
                _setPausedState: {
                    value: function (f, p) {
                        if (o.paused === f) return this;
                        if (((o.paused = f), f)) {
                            var h = l(p, "onPause"),
                                S = l(p, "onPostPause");
                            h?.(), P(), _(), S?.();
                        } else {
                            var v = l(p, "onUnpause"),
                                w = l(p, "onPostUnpause");
                            v?.(), d(), R(), _(), w?.();
                        }
                        return this;
                    },
                },
            }),
            a.updateContainerElements(e),
            a
        );
    };
function St(t, e) {
    let r = t.indexOf(e);
    r > -1 && t.splice(r, 1);
}
var z = (t, e, r) => (r > e ? e : r < t ? t : r);
var ue = () => {},
    W = () => {};
var de = {};
function Ee(t) {
    return typeof t == "object" && t !== null;
}
function Se(t) {
    let e;
    return () => (e === void 0 && (e = t()), e);
}
var V = (t) => t;
var vn = (t, e) => (r) => e(t(r)),
    Te = (...t) => t.reduce(vn);
var Y = (t, e, r) => {
    let i = e - t;
    return i === 0 ? 1 : (r - t) / i;
};
var B = (t) => t * 1e3,
    K = (t) => t / 1e3;
function Ae(t, e) {
    return e ? t * (1e3 / e) : 0;
}
var vr = (t, e, r) => {
    let i = e - t;
    return ((((r - t) % i) + i) % i) + t;
};
var yr = (t, e, r) => (((1 - 3 * r + 3 * e) * t + (3 * r - 6 * e)) * t + 3 * e) * t,
    yn = 1e-7,
    bn = 12;
function xn(t, e, r, i, n) {
    let s,
        o,
        a = 0;
    do (o = e + (r - e) / 2), (s = yr(o, i, n) - t), s > 0 ? (r = o) : (e = o);
    while (Math.abs(s) > yn && ++a < bn);
    return o;
}
function ie(t, e, r, i) {
    if (t === e && r === i) return V;
    let n = (s) => xn(s, 0, 1, t, r);
    return (s) => (s === 0 || s === 1 ? s : yr(n(s), e, i));
}
var Ze = (t) => (e) => (e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2);
var Xe = (t) => (e) => 1 - t(1 - e);
var Tt = ie(0.33, 1.53, 0.69, 0.99),
    Oe = Xe(Tt),
    br = Ze(Oe);
var xr = (t) => ((t *= 2) < 1 ? 0.5 * Oe(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))));
var Ye = (t) => 1 - Math.sin(Math.acos(t)),
    wr = Xe(Ye),
    Er = Ze(Ye);
var Sr = ie(0.42, 0, 1, 1),
    Tr = ie(0, 0, 0.58, 1),
    Ar = ie(0.42, 0, 0.58, 1);
var Or = (t) => Array.isArray(t) && typeof t[0] != "number";
function Ie(t, e) {
    return Or(t) ? t[vr(0, t.length, e)] : t;
}
var De = (t) => Array.isArray(t) && typeof t[0] == "number";
var Ir = {
        linear: V,
        easeIn: Sr,
        easeInOut: Ar,
        easeOut: Tr,
        circIn: Ye,
        circInOut: Er,
        circOut: wr,
        backIn: Oe,
        backInOut: br,
        backOut: Tt,
        anticipate: xr,
    },
    wn = (t) => typeof t == "string",
    At = (t) => {
        if (De(t)) {
            W(t.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
            let [e, r, i, n] = t;
            return ie(e, r, i, n);
        } else if (wn(t)) return W(Ir[t] !== void 0, `Invalid easing type '${t}'`, "invalid-easing-type"), Ir[t];
        return t;
    };
var Fe = ["setup", "read", "resolveKeyframes", "preUpdate", "update", "preRender", "render", "postRender"];
var he = { value: null, addProjectionMetrics: null };
function Dr(t, e) {
    let r = new Set(),
        i = new Set(),
        n = !1,
        s = !1,
        o = new WeakSet(),
        a = { delta: 0, timestamp: 0, isProcessing: !1 },
        l = 0;
    function c(u) {
        o.has(u) && (m.schedule(u), t()), l++, u(a);
    }
    let m = {
        schedule: (u, d = !1, g = !1) => {
            let E = g && n ? r : i;
            return d && o.add(u), E.has(u) || E.add(u), u;
        },
        cancel: (u) => {
            i.delete(u), o.delete(u);
        },
        process: (u) => {
            if (((a = u), n)) {
                s = !0;
                return;
            }
            (n = !0),
                ([r, i] = [i, r]),
                r.forEach(c),
                e && he.value && he.value.frameloop[e].push(l),
                (l = 0),
                r.clear(),
                (n = !1),
                s && ((s = !1), m.process(u));
        },
    };
    return m;
}
var En = 40;
function Fr(t, e) {
    let r = !1,
        i = !0,
        n = { delta: 0, timestamp: 0, isProcessing: !1 },
        s = () => (r = !0),
        o = Fe.reduce((F, I) => ((F[I] = Dr(s, e ? I : void 0)), F), {}),
        { setup: a, read: l, resolveKeyframes: c, preUpdate: m, update: u, preRender: d, render: g, postRender: y } = o,
        E = () => {
            let F = de.useManualTiming ? n.timestamp : performance.now();
            (r = !1),
                de.useManualTiming || (n.delta = i ? 1e3 / 60 : Math.max(Math.min(F - n.timestamp, En), 1)),
                (n.timestamp = F),
                (n.isProcessing = !0),
                a.process(n),
                l.process(n),
                c.process(n),
                m.process(n),
                u.process(n),
                d.process(n),
                g.process(n),
                y.process(n),
                (n.isProcessing = !1),
                r && e && ((i = !1), t(E));
        },
        A = () => {
            (r = !0), (i = !0), n.isProcessing || t(E);
        };
    return {
        schedule: Fe.reduce((F, I) => {
            let b = o[I];
            return (F[I] = (D, R = !1, P = !1) => (r || A(), b.schedule(D, R, P))), F;
        }, {}),
        cancel: (F) => {
            for (let I = 0; I < Fe.length; I++) o[Fe[I]].cancel(F);
        },
        state: n,
        steps: o,
    };
}
var {
    schedule: ne,
    cancel: Me,
    state: Ot,
    steps: Sn,
} = Fr(typeof requestAnimationFrame < "u" ? requestAnimationFrame : V, !0);
var It = { layout: 0, mainThread: 0, waapi: 0 };
var Tn = (t) => (e) => typeof e == "string" && e.startsWith(t);
var An = Tn("var(--"),
    Mr = (t) => (An(t) ? On.test(t.split("/*")[0].trim()) : !1),
    On = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
var Je = { test: (t) => typeof t == "number", parse: parseFloat, transform: (t) => t },
    Qe = { ...Je, transform: (t) => z(0, 1, t) },
    Ys = { ...Je, default: 1 };
var oe = (t) => Math.round(t * 1e5) / 1e5;
var et = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function Nr(t) {
    return t == null;
}
var Cr =
    /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;
var ge = (t, e) => (r) =>
        !!(
            (typeof r == "string" && Cr.test(r) && r.startsWith(t)) ||
            (e && !Nr(r) && Object.prototype.hasOwnProperty.call(r, e))
        ),
    tt = (t, e, r) => (i) => {
        if (typeof i != "string") return i;
        let [n, s, o, a] = i.match(et);
        return { [t]: parseFloat(n), [e]: parseFloat(s), [r]: parseFloat(o), alpha: a !== void 0 ? parseFloat(a) : 1 };
    };
var In = (t) => z(0, 255, t),
    Dt = { ...Je, transform: (t) => Math.round(In(t)) },
    Z = {
        test: ge("rgb", "red"),
        parse: tt("red", "green", "blue"),
        transform: ({ red: t, green: e, blue: r, alpha: i = 1 }) =>
            "rgba(" +
            Dt.transform(t) +
            ", " +
            Dt.transform(e) +
            ", " +
            Dt.transform(r) +
            ", " +
            oe(Qe.transform(i)) +
            ")",
    };
function Dn(t) {
    let e = "",
        r = "",
        i = "",
        n = "";
    return (
        t.length > 5
            ? ((e = t.substring(1, 3)), (r = t.substring(3, 5)), (i = t.substring(5, 7)), (n = t.substring(7, 9)))
            : ((e = t.substring(1, 2)),
              (r = t.substring(2, 3)),
              (i = t.substring(3, 4)),
              (n = t.substring(4, 5)),
              (e += e),
              (r += r),
              (i += i),
              (n += n)),
        { red: parseInt(e, 16), green: parseInt(r, 16), blue: parseInt(i, 16), alpha: n ? parseInt(n, 16) / 255 : 1 }
    );
}
var Ne = { test: ge("#"), parse: Dn, transform: Z.transform };
var Fn = (t) => ({
    test: (e) => typeof e == "string" && e.endsWith(t) && e.split(" ").length === 1,
    parse: parseFloat,
    transform: (e) => `${e}${t}`,
});
var Ft = Fn("%");
var se = {
    test: ge("hsl", "hue"),
    parse: tt("hue", "saturation", "lightness"),
    transform: ({ hue: t, saturation: e, lightness: r, alpha: i = 1 }) =>
        "hsla(" +
        Math.round(t) +
        ", " +
        Ft.transform(oe(e)) +
        ", " +
        Ft.transform(oe(r)) +
        ", " +
        oe(Qe.transform(i)) +
        ")",
};
var H = {
    test: (t) => Z.test(t) || Ne.test(t) || se.test(t),
    parse: (t) => (Z.test(t) ? Z.parse(t) : se.test(t) ? se.parse(t) : Ne.parse(t)),
    transform: (t) => (typeof t == "string" ? t : t.hasOwnProperty("red") ? Z.transform(t) : se.transform(t)),
    getAnimatableNone: (t) => {
        let e = H.parse(t);
        return (e.alpha = 0), H.transform(e);
    },
};
var Rr =
    /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function Mn(t) {
    return isNaN(t) && typeof t == "string" && (t.match(et)?.length || 0) + (t.match(Rr)?.length || 0) > 0;
}
var Lr = "number",
    Pr = "color",
    Nn = "var",
    Cn = "var(",
    kr = "${}",
    Rn =
        /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Ce(t) {
    let e = t.toString(),
        r = [],
        i = { color: [], number: [], var: [] },
        n = [],
        s = 0,
        a = e
            .replace(
                Rn,
                (l) => (
                    H.test(l)
                        ? (i.color.push(s), n.push(Pr), r.push(H.parse(l)))
                        : l.startsWith(Cn)
                          ? (i.var.push(s), n.push(Nn), r.push(l))
                          : (i.number.push(s), n.push(Lr), r.push(parseFloat(l))),
                    ++s,
                    kr
                )
            )
            .split(kr);
    return { values: r, split: a, indexes: i, types: n };
}
function _r(t) {
    return Ce(t).values;
}
function Vr(t) {
    let { split: e, types: r } = Ce(t),
        i = e.length;
    return (n) => {
        let s = "";
        for (let o = 0; o < i; o++)
            if (((s += e[o]), n[o] !== void 0)) {
                let a = r[o];
                a === Lr ? (s += oe(n[o])) : a === Pr ? (s += H.transform(n[o])) : (s += n[o]);
            }
        return s;
    };
}
var kn = (t) => (typeof t == "number" ? 0 : H.test(t) ? H.getAnimatableNone(t) : t);
function Ln(t) {
    let e = _r(t);
    return Vr(t)(e.map(kn));
}
var zr = { test: Mn, parse: _r, createTransformer: Vr, getAnimatableNone: Ln };
function Mt(t, e, r) {
    return (
        r < 0 && (r += 1),
        r > 1 && (r -= 1),
        r < 1 / 6 ? t + (e - t) * 6 * r : r < 1 / 2 ? e : r < 2 / 3 ? t + (e - t) * (2 / 3 - r) * 6 : t
    );
}
function Br({ hue: t, saturation: e, lightness: r, alpha: i }) {
    (t /= 360), (e /= 100), (r /= 100);
    let n = 0,
        s = 0,
        o = 0;
    if (!e) n = s = o = r;
    else {
        let a = r < 0.5 ? r * (1 + e) : r + e - r * e,
            l = 2 * r - a;
        (n = Mt(l, a, t + 1 / 3)), (s = Mt(l, a, t)), (o = Mt(l, a, t - 1 / 3));
    }
    return { red: Math.round(n * 255), green: Math.round(s * 255), blue: Math.round(o * 255), alpha: i };
}
function ve(t, e) {
    return (r) => (r > 0 ? e : t);
}
var q = (t, e, r) => t + (e - t) * r;
var Nt = (t, e, r) => {
        let i = t * t,
            n = r * (e * e - i) + i;
        return n < 0 ? 0 : Math.sqrt(n);
    },
    Pn = [Ne, Z, se],
    _n = (t) => Pn.find((e) => e.test(t));
function Wr(t) {
    let e = _n(t);
    if (
        (ue(!!e, `'${t}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"),
        !e)
    )
        return !1;
    let r = e.parse(t);
    return e === se && (r = Br(r)), r;
}
var Ct = (t, e) => {
    let r = Wr(t),
        i = Wr(e);
    if (!r || !i) return ve(t, e);
    let n = { ...r };
    return (s) => (
        (n.red = Nt(r.red, i.red, s)),
        (n.green = Nt(r.green, i.green, s)),
        (n.blue = Nt(r.blue, i.blue, s)),
        (n.alpha = q(r.alpha, i.alpha, s)),
        Z.transform(n)
    );
};
var rt = new Set(["none", "hidden"]);
function Kr(t, e) {
    return rt.has(t) ? (r) => (r <= 0 ? t : e) : (r) => (r >= 1 ? e : t);
}
function Vn(t, e) {
    return (r) => q(t, e, r);
}

function $r(t, e, r) {
    return typeof t == "number" && typeof e == "number" && typeof r == "number" ? q(t, e, r) : it(t)(t, e);
}
var nt = (t, e, r = 10) => {
    let i = "",
        n = Math.max(Math.round(e / r), 2);
    for (let s = 0; s < n; s++) i += Math.round(t(s / (n - 1)) * 1e4) / 1e4 + ", ";
    return `linear(${i.substring(0, i.length - 2)})`;
};
function ot(t) {
    let e = 0,
        r = 50,
        i = t.next(e);
    for (; !i.done && e < 2e4; ) (e += r), (i = t.next(e));
    return e >= 2e4 ? 1 / 0 : e;
}
function Re(t, e = 100, r) {
    let i = r({ ...t, keyframes: [0, e] }),
        n = Math.min(ot(i), 2e4);
    return { type: "keyframes", ease: (s) => i.next(n * s).value / e, duration: K(n) };
}
var Kn = 5;
function jr(t, e, r) {
    let i = Math.max(e - Kn, 0);
    return Ae(r - t(i), e - i);
}
var M = {
    stiffness: 100,
    damping: 10,
    mass: 1,
    velocity: 0,
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    restSpeed: { granular: 0.01, default: 2 },
    restDelta: { granular: 0.005, default: 0.5 },
    minDuration: 0.01,
    maxDuration: 10,
    minDamping: 0.05,
    maxDamping: 1,
};
var kt = 0.001;
// function Hr({ duration: t = M.duration, bounce: e = M.bounce, velocity: r = M.velocity, mass: i = M.mass }) {
//     let n, s;
//     ue(t <= B(M.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
//     let o = 1 - e;
//     (o = z(M.minDamping, M.maxDamping, o)),
//         (t = z(M.minDuration, M.maxDuration, K(t))),
//         o < 1
//             ? ((n = (c) => {
//                   let m = c * o,
//                       u = m * t,
//                       d = m - r,
//                       g = st(c, o),
//                       y = Math.exp(-u);
//                   return kt - (d / g) * y;
//               }),
//               (s = (c) => {
//                   let u = c * o * t,
//                       d = u * r + r,
//                       g = Math.pow(o, 2) * Math.pow(c, 2) * t,
//                       y = Math.exp(-u),
//                       E = st(Math.pow(c, 2), o);
//                   return ((-n(c) + kt > 0 ? -1 : 1) * ((d - g) * y)) / E;
//               }))
//             : ((n = (c) => {
//                   let m = Math.exp(-c * t),
//                       u = (c - r) * t + 1;
//                   return -kt + m * u;
//               }),
//               (s = (c) => {
//                   let m = Math.exp(-c * t),
//                       u = (r - c) * (t * t);
//                   return m * u;
//               }));
//     let a = 5 / t,
//         l = $n(n, s, a);
//     if (((t = B(t)), isNaN(l))) return { stiffness: M.stiffness, damping: M.damping, duration: t };
//     {
//         let c = Math.pow(l, 2) * i;
//         return { stiffness: c, damping: o * 2 * Math.sqrt(i * c), duration: t };
//     }
// }
// var Gn = 12;
// function $n(t, e, r) {
//     let i = r;
//     for (let n = 1; n < Gn; n++) i = i - t(i) / e(i);
//     return i;
// }
// function st(t, e) {
//     return t * Math.sqrt(1 - e * e);
// }
// var jn = ["duration", "bounce"],
//     Hn = ["stiffness", "damping", "mass"];
// function qr(t, e) {
//     return e.some((r) => t[r] !== void 0);
// }
// function qn(t) {
//     let e = {
//         velocity: M.velocity,
//         stiffness: M.stiffness,
//         damping: M.damping,
//         mass: M.mass,
//         isResolvedFromDuration: !1,
//         ...t,
//     };
//     if (!qr(t, Hn) && qr(t, jn))
//         if (t.visualDuration) {
//             let r = t.visualDuration,
//                 i = (2 * Math.PI) / (r * 1.2),
//                 n = i * i,
//                 s = 2 * z(0.05, 1, 1 - (t.bounce || 0)) * Math.sqrt(n);
//             e = { ...e, mass: M.mass, stiffness: n, damping: s };
//         } else {
//             let r = Hr(t);
//             (e = { ...e, ...r, mass: M.mass }), (e.isResolvedFromDuration = !0);
//         }
//     return e;
// }
// function at(t = M.visualDuration, e = M.bounce) {
//     let r = typeof t != "object" ? { visualDuration: t, keyframes: [0, 1], bounce: e } : t,
//         { restSpeed: i, restDelta: n } = r,
//         s = r.keyframes[0],
//         o = r.keyframes[r.keyframes.length - 1],
//         a = { done: !1, value: s },
//         {
//             stiffness: l,
//             damping: c,
//             mass: m,
//             duration: u,
//             velocity: d,
//             isResolvedFromDuration: g,
//         } = qn({ ...r, velocity: -K(r.velocity || 0) }),
//         y = d || 0,
//         E = c / (2 * Math.sqrt(l * m)),
//         A = o - s,
//         O = K(Math.sqrt(l / m)),
//         L = Math.abs(A) < 5;
//     i || (i = L ? M.restSpeed.granular : M.restSpeed.default),
//         n || (n = L ? M.restDelta.granular : M.restDelta.default);
//     let F;
//     if (E < 1) {
//         let b = st(O, E);
//         F = (D) => {
//             let R = Math.exp(-E * O * D);
//             return o - R * (((y + E * O * A) / b) * Math.sin(b * D) + A * Math.cos(b * D));
//         };
//     } else if (E === 1) F = (b) => o - Math.exp(-O * b) * (A + (y + O * A) * b);
//     else {
//         let b = O * Math.sqrt(E * E - 1);
//         F = (D) => {
//             let R = Math.exp(-E * O * D),
//                 P = Math.min(b * D, 300);
//             return o - (R * ((y + E * O * A) * Math.sinh(P) + b * A * Math.cosh(P))) / b;
//         };
//     }
//     let I = {
//         calculatedDuration: (g && u) || null,
//         next: (b) => {
//             let D = F(b);
//             if (g) a.done = b >= u;
//             else {
//                 let R = b === 0 ? y : 0;
//                 E < 1 && (R = b === 0 ? B(y) : jr(F, b, D));
//                 let P = Math.abs(R) <= i,
//                     k = Math.abs(o - D) <= n;
//                 a.done = P && k;
//             }
//             return (a.value = a.done ? o : D), a;
//         },
//         toString: () => {
//             let b = Math.min(ot(I), 2e4),
//                 D = nt((R) => I.next(b * R).value, b, 30);
//             return b + "ms " + D;
//         },
//         toTransition: () => {},
//     };
//     return I;
// }
// at.applyToOptions = (t) => {
//     let e = Re(t, 100, at);
//     return (t.ease = e.ease), (t.duration = B(e.duration)), (t.type = "keyframes"), t;
// };
// function Un(t, e, r) {
//     let i = [],
//         n = r || de.mix || $r,
//         s = t.length - 1;
//     for (let o = 0; o < s; o++) {
//         let a = n(t[o], t[o + 1]);
//         if (e) {
//             let l = Array.isArray(e) ? e[o] || V : e;
//             a = Te(l, a);
//         }
//         i.push(a);
//     }
//     return i;
// }
// function Lt(t, e, { clamp: r = !0, ease: i, mixer: n } = {}) {
//     let s = t.length;
//     if ((W(s === e.length, "Both input and output ranges must be the same length", "range-length"), s === 1))
//         return () => e[0];
//     if (s === 2 && e[0] === e[1]) return () => e[1];
//     let o = t[0] === t[1];
//     t[0] > t[s - 1] && ((t = [...t].reverse()), (e = [...e].reverse()));
//     let a = Un(e, i, n),
//         l = a.length,
//         c = (m) => {
//             if (o && m < t[0]) return e[0];
//             let u = 0;
//             if (l > 1) for (; u < t.length - 2 && !(m < t[u + 1]); u++);
//             let d = Y(t[u], t[u + 1], m);
//             return a[u](d);
//         };
//     return r ? (m) => c(z(t[0], t[s - 1], m)) : c;
// }
function ke(t, e) {
    let r = t[t.length - 1];
    for (let i = 1; i <= e; i++) {
        let n = Y(0, e, i);
        t.push(q(r, 1, n));
    }
}
function Le(t) {
    let e = [0];
    return ke(e, t.length - 1), e;
}
var Zn = (t) => t !== null;
function Ur(t, { repeat: e, repeatType: r = "loop" }, i, n = 1) {
    let s = t.filter(Zn),
        a = n < 0 || (e && r !== "loop" && e % 2 === 1) ? 0 : s.length - 1;
    return !a || i === void 0 ? s[a] : i;
}
var lt = class {
    constructor() {
        this.updateFinished();
    }
    get finished() {
        return this._finished;
    }
    updateFinished() {
        this._finished = new Promise((e) => {
            this.resolve = e;
        });
    }
    notifyFinished() {
        this.resolve();
    }
    then(e, r) {
        return this.finished.then(e, r);
    }
};
function Pt(t) {
    for (let e = 1; e < t.length; e++) t[e] ?? (t[e] = t[e - 1]);
}
var ct = (t) => t.startsWith("--");
function Zr(t, e, r) {
    ct(e) ? t.style.setProperty(e, r) : (t.style[e] = r);
}
var Pe = Se(() => window.ScrollTimeline !== void 0);
var Xr = {};
function Yr(t, e) {
    let r = Se(t);
    return () => Xr[e] ?? r();
}
var ft = Yr(() => {
    try {
        document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
    } catch {
        return !1;
    }
    return !0;
}, "linearEasing");
var pe = ([t, e, r, i]) => `cubic-bezier(${t}, ${e}, ${r}, ${i})`;
var _t = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: pe([0, 0.65, 0.55, 1]),
    circOut: pe([0.55, 0, 1, 0.45]),
    backIn: pe([0.31, 0.01, 0.66, -0.59]),
    backOut: pe([0.33, 1.53, 0.69, 0.99]),
};
function Vt(t, e) {
    if (t)
        return typeof t == "function"
            ? ft()
                ? nt(t, e)
                : "ease-out"
            : De(t)
              ? pe(t)
              : Array.isArray(t)
                ? t.map((r) => Vt(r, e) || _t.easeOut)
                : _t[t];
}
function Jr(
    t,
    e,
    r,
    { delay: i = 0, duration: n = 300, repeat: s = 0, repeatType: o = "loop", ease: a = "easeOut", times: l } = {},
    c = void 0
) {
    let m = { [e]: r };
    l && (m.offset = l);
    let u = Vt(a, n);
    Array.isArray(u) && (m.easing = u), he.value && It.waapi++;
    let d = {
        delay: i,
        duration: n,
        easing: Array.isArray(u) ? "linear" : u,
        fill: "both",
        iterations: s + 1,
        direction: o === "reverse" ? "alternate" : "normal",
    };
    c && (d.pseudoElement = c);
    let g = t.animate(m, d);
    return (
        he.value &&
            g.finished.finally(() => {
                It.waapi--;
            }),
        g
    );
}
function _e(t) {
    return typeof t == "function" && "applyToOptions" in t;
}
function Qr({ type: t, ...e }) {
    return _e(t) && ft() ? t.applyToOptions(e) : (e.duration ?? (e.duration = 300), e.ease ?? (e.ease = "easeOut"), e);
}
var Ve = class extends lt {
    constructor(e) {
        if ((super(), (this.finishedTime = null), (this.isStopped = !1), !e)) return;
        let {
            element: r,
            name: i,
            keyframes: n,
            pseudoElement: s,
            allowFlatten: o = !1,
            finalKeyframe: a,
            onComplete: l,
        } = e;
        (this.isPseudoElement = !!s),
            (this.allowFlatten = o),
            (this.options = e),
            W(typeof e.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
        let c = Qr(e);
        (this.animation = Jr(r, i, n, c, s)),
            c.autoplay === !1 && this.animation.pause(),
            (this.animation.onfinish = () => {
                if (((this.finishedTime = this.time), !s)) {
                    let m = Ur(n, this.options, a, this.speed);
                    this.updateMotionValue ? this.updateMotionValue(m) : Zr(r, i, m), this.animation.cancel();
                }
                l?.(), this.notifyFinished();
            });
    }
    play() {
        this.isStopped || (this.animation.play(), this.state === "finished" && this.updateFinished());
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.finish?.();
    }
    cancel() {
        try {
            this.animation.cancel();
        } catch {}
    }
    stop() {
        if (this.isStopped) return;
        this.isStopped = !0;
        let { state: e } = this;
        e === "idle" ||
            e === "finished" ||
            (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(),
            this.isPseudoElement || this.cancel());
    }
    commitStyles() {
        this.isPseudoElement || this.animation.commitStyles?.();
    }
    get duration() {
        let e = this.animation.effect?.getComputedTiming?.().duration || 0;
        return K(Number(e));
    }
    get iterationDuration() {
        let { delay: e = 0 } = this.options || {};
        return this.duration + K(e);
    }
    get time() {
        return K(Number(this.animation.currentTime) || 0);
    }
    set time(e) {
        (this.finishedTime = null), (this.animation.currentTime = B(e));
    }
    get speed() {
        return this.animation.playbackRate;
    }
    set speed(e) {
        e < 0 && (this.finishedTime = null), (this.animation.playbackRate = e);
    }
    get state() {
        return this.finishedTime !== null ? "finished" : this.animation.playState;
    }
    get startTime() {
        return Number(this.animation.startTime);
    }
    set startTime(e) {
        this.animation.startTime = e;
    }
    attachTimeline({ timeline: e, observe: r }) {
        return (
            this.allowFlatten && this.animation.effect?.updateTiming({ easing: "linear" }),
            (this.animation.onfinish = null),
            e && Pe() ? ((this.animation.timeline = e), V) : r(this)
        );
    }
};
var ut = class {
    constructor(e) {
        (this.stop = () => this.runAll("stop")), (this.animations = e.filter(Boolean));
    }
    get finished() {
        return Promise.all(this.animations.map((e) => e.finished));
    }
    getAll(e) {
        return this.animations[0][e];
    }
    setAll(e, r) {
        for (let i = 0; i < this.animations.length; i++) this.animations[i][e] = r;
    }
    attachTimeline(e) {
        let r = this.animations.map((i) => i.attachTimeline(e));
        return () => {
            r.forEach((i, n) => {
                i && i(), this.animations[n].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(e) {
        this.setAll("time", e);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(e) {
        this.setAll("speed", e);
    }
    get state() {
        return this.getAll("state");
    }
    get startTime() {
        return this.getAll("startTime");
    }
    get duration() {
        return ei(this.animations, "duration");
    }
    get iterationDuration() {
        return ei(this.animations, "iterationDuration");
    }
    runAll(e) {
        this.animations.forEach((r) => r[e]());
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
};
function ei(t, e) {
    let r = 0;
    for (let i = 0; i < t.length; i++) {
        let n = t[i][e];
        n !== null && n > r && (r = n);
    }
    return r;
}
var me = class extends ut {
    then(e, r) {
        return this.finished.finally(e).then(() => {});
    }
};
var ti = new WeakMap(),
    zt = (t, e = "") => `${t}:${e}`;
function Bt(t) {
    let e = ti.get(t) || new Map();
    return ti.set(t, e), e;
}
function Wt(t, e) {
    return t?.[e] ?? t?.default ?? t;
}
var ri = new Set([
    "borderWidth",
    "borderTopWidth",
    "borderRightWidth",
    "borderBottomWidth",
    "borderLeftWidth",
    "borderRadius",
    "radius",
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomRightRadius",
    "borderBottomLeftRadius",
    "width",
    "maxWidth",
    "height",
    "maxHeight",
    "top",
    "right",
    "bottom",
    "left",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "backgroundPositionX",
    "backgroundPositionY",
]);
function Kt(t, e) {
    for (let r = 0; r < t.length; r++) typeof t[r] == "number" && ri.has(e) && (t[r] = t[r] + "px");
}
function J(t, e, r) {
    if (t instanceof EventTarget) return [t];
    if (typeof t == "string") {
        let i = document;
        e && (i = e.current);
        let n = r?.[t] ?? i.querySelectorAll(t);
        return n ? Array.from(n) : [];
    }
    return Array.from(t);
}
function Gt(t) {
    return Ee(t) && "offsetHeight" in t;
}
function pt(t, e) {
    let r = window.getComputedStyle(t);
    return ct(e) ? r.getPropertyValue(e) : r[e];
}
function ii(t) {
    return Ee(t) && "ownerSVGElement" in t;
}
var mt = new WeakMap(),
    dt,
    ni = (t, e, r) => (i, n) => (n && n[0] ? n[0][t + "Size"] : ii(i) && "getBBox" in i ? i.getBBox()[e] : i[r]),
    Xn = ni("inline", "width", "offsetWidth"),
    Yn = ni("block", "height", "offsetHeight");
function Jn({ target: t, borderBoxSize: e }) {
    mt.get(t)?.forEach((r) => {
        r(t, {
            get width() {
                return Xn(t, e);
            },
            get height() {
                return Yn(t, e);
            },
        });
    });
}
function Qn(t) {
    t.forEach(Jn);
}
function eo() {
    typeof ResizeObserver > "u" || (dt = new ResizeObserver(Qn));
}
function oi(t, e) {
    dt || eo();
    let r = J(t);
    return (
        r.forEach((i) => {
            let n = mt.get(i);
            n || ((n = new Set()), mt.set(i, n)), n.add(e), dt?.observe(i);
        }),
        () => {
            r.forEach((i) => {
                let n = mt.get(i);
                n?.delete(e), n?.size || dt?.unobserve(i);
            });
        }
    );
}
var ht = new Set(),
    ye;
function to() {
    (ye = () => {
        let t = {
            get width() {
                return window.innerWidth;
            },
            get height() {
                return window.innerHeight;
            },
        };
        ht.forEach((e) => e(t));
    }),
        window.addEventListener("resize", ye);
}
function si(t) {
    return (
        ht.add(t),
        ye || to(),
        () => {
            ht.delete(t),
                !ht.size && typeof ye == "function" && (window.removeEventListener("resize", ye), (ye = void 0));
        }
    );
}
function $t(t, e) {
    return typeof t == "function" ? si(t) : oi(t, e);
}
function ze(t, e) {
    let r,
        i = () => {
            let { currentTime: n } = e,
                o = (n === null ? 0 : n.value) / 100;
            r !== o && t(o), (r = o);
        };
    return ne.preUpdate(i, !0), () => Me(i);
}
function ai(t, e) {
    if (t === "first") return 0;
    {
        let r = e - 1;
        return t === "last" ? r : r / 2;
    }
}
function li(t = 0.1, { startDelay: e = 0, from: r = 0, ease: i } = {}) {
    return (n, s) => {
        let o = typeof r == "number" ? r : ai(r, s),
            a = Math.abs(o - n),
            l = t * a;
        if (i) {
            let c = s * t;
            l = At(i)(l / c) * c;
        }
        return e + l;
    };
}
var jt = (t) => !!(t && t.getVelocity);
function ci(t) {
    return typeof t == "object" && !Array.isArray(t);
}
function fi(t, e, r, i) {
    return typeof t == "string" && ci(e)
        ? J(t, r, i)
        : t instanceof NodeList
          ? Array.from(t)
          : Array.isArray(t)
            ? t
            : [t];
}
function ui(t, e, r) {
    return t * (e + 1);
}
function Ht(t, e, r, i) {
    return typeof e == "number"
        ? e
        : e.startsWith("-") || e.startsWith("+")
          ? Math.max(0, t + parseFloat(e))
          : e === "<"
            ? r
            : e.startsWith("<")
              ? Math.max(0, r + parseFloat(e.slice(1)))
              : (i.get(e) ?? t);
}
function ro(t, e, r) {
    for (let i = 0; i < t.length; i++) {
        let n = t[i];
        n.at > e && n.at < r && (St(t, n), i--);
    }
}
function pi(t, e, r, i, n, s) {
    ro(t, n, s);
    for (let o = 0; o < e.length; o++) t.push({ value: e[o], at: q(n, s, i[o]), easing: Ie(r, o) });
}
function mi(t, e) {
    for (let r = 0; r < t.length; r++) t[r] = t[r] / (e + 1);
}
function di(t, e) {
    return t.at === e.at ? (t.value === null ? 1 : e.value === null ? -1 : 0) : t.at - e.at;
}
var io = "easeInOut",
    no = 20;
function vi(t, { defaultTransition: e = {}, ...r } = {}, i, n) {
    let s = e.duration || 0.3,
        o = new Map(),
        a = new Map(),
        l = {},
        c = new Map(),
        m = 0,
        u = 0,
        d = 0;
    for (let g = 0; g < t.length; g++) {
        let y = t[g];
        if (typeof y == "string") {
            c.set(y, u);
            continue;
        } else if (!Array.isArray(y)) {
            c.set(y.name, Ht(u, y.at, m, c));
            continue;
        }
        let [E, A, O = {}] = y;
        O.at !== void 0 && (u = Ht(u, O.at, m, c));
        let L = 0,
            F = (I, b, D, R = 0, P = 0) => {
                let k = oo(I),
                    {
                        delay: ae = 0,
                        times: _ = Le(k),
                        type: T = "keyframes",
                        repeat: f,
                        repeatType: p,
                        repeatDelay: h = 0,
                        ...S
                    } = b,
                    { ease: v = e.ease || "easeOut", duration: w } = b,
                    x = typeof ae == "function" ? ae(R, P) : ae,
                    N = k.length,
                    C = _e(T) ? T : n?.[T || "keyframes"];
                if (N <= 2 && C) {
                    let j = 100;
                    if (N === 2 && lo(k)) {
                        let X = k[1] - k[0];
                        j = Math.abs(X);
                    }
                    let le = { ...S };
                    w !== void 0 && (le.duration = B(w));
                    let te = Re(le, j, C);
                    (v = te.ease), (w = te.duration);
                }
                w ?? (w = s);
                let U = u + x;
                _.length === 1 && _[0] === 0 && (_[1] = 1);
                let ee = _.length - k.length;
                if ((ee > 0 && ke(_, ee), k.length === 1 && k.unshift(null), f)) {
                    W(f < no, "Repeat count too high, must be less than 20", "repeat-count-high"), (w = ui(w, f));
                    let j = [...k],
                        le = [..._];
                    v = Array.isArray(v) ? [...v] : [v];
                    let te = [...v];
                    for (let X = 0; X < f; X++) {
                        k.push(...j);
                        for (let be = 0; be < j.length; be++)
                            _.push(le[be] + (X + 1)), v.push(be === 0 ? "linear" : Ie(te, be - 1));
                    }
                    mi(_, f);
                }
                let $ = U + w;
                pi(D, k, v, _, U, $), (L = Math.max(x + w, L)), (d = Math.max($, d));
            };
        if (jt(E)) {
            let I = hi(E, a);
            F(A, O, gi("default", I));
        } else {
            let I = fi(E, A, i, l),
                b = I.length;
            for (let D = 0; D < b; D++) {
                (A = A), (O = O);
                let R = I[D],
                    P = hi(R, a);
                for (let k in A) F(A[k], so(O, k), gi(k, P), D, b);
            }
        }
        (m = u), (u += L);
    }
    return (
        a.forEach((g, y) => {
            for (let E in g) {
                let A = g[E];
                A.sort(di);
                let O = [],
                    L = [],
                    F = [];
                for (let b = 0; b < A.length; b++) {
                    let { at: D, value: R, easing: P } = A[b];
                    O.push(R), L.push(Y(0, d, D)), F.push(P || "easeOut");
                }
                L[0] !== 0 && (L.unshift(0), O.unshift(O[0]), F.unshift(io)),
                    L[L.length - 1] !== 1 && (L.push(1), O.push(null)),
                    o.has(y) || o.set(y, { keyframes: {}, transition: {} });
                let I = o.get(y);
                (I.keyframes[E] = O), (I.transition[E] = { ...e, duration: d, ease: F, times: L, ...r });
            }
        }),
        o
    );
}
function hi(t, e) {
    return !e.has(t) && e.set(t, {}), e.get(t);
}
function gi(t, e) {
    return e[t] || (e[t] = []), e[t];
}
function oo(t) {
    return Array.isArray(t) ? t : [t];
}
function so(t, e) {
    return t && t[e] ? { ...t, ...t[e] } : { ...t };
}
var ao = (t) => typeof t == "number",
    lo = (t) => t.every(ao);
function gt(t, e, r, i) {
    let n = J(t, i),
        s = n.length;
    W(!!s, "No valid elements provided.", "no-valid-elements");
    let o = [];
    for (let l = 0; l < s; l++) {
        let c = n[l],
            m = { ...r };
        typeof m.delay == "function" && (m.delay = m.delay(l, s));
        for (let u in e) {
            let d = e[u];
            Array.isArray(d) || (d = [d]);
            let g = { ...Wt(m, u) };
            g.duration && (g.duration = B(g.duration)), g.delay && (g.delay = B(g.delay));
            let y = Bt(c),
                E = zt(u, g.pseudoElement || ""),
                A = y.get(E);
            A && A.stop(),
                o.push({
                    map: y,
                    key: E,
                    unresolvedKeyframes: d,
                    options: { ...g, element: c, name: u, allowFlatten: !m.type && !m.ease },
                });
        }
    }
    for (let l = 0; l < o.length; l++) {
        let { unresolvedKeyframes: c, options: m } = o[l],
            { element: u, name: d, pseudoElement: g } = m;
        !g && c[0] === null && (c[0] = pt(u, d)),
            Pt(c),
            Kt(c, d),
            !g && c.length < 2 && c.unshift(pt(u, d)),
            (m.keyframes = c);
    }
    let a = [];
    for (let l = 0; l < o.length; l++) {
        let { map: c, key: m, options: u } = o[l],
            d = new Ve(u);
        c.set(m, d), d.finished.finally(() => c.delete(m)), a.push(d);
    }
    return a;
}
function yi(t, e) {
    let r = [];
    return (
        vi(t, e).forEach(({ keyframes: i, transition: n }, s) => {
            r.push(...gt(s, i, n));
        }),
        new me(r)
    );
}
var co = (t) => {
        function e(r, i, n) {
            return new me(gt(r, i, n, t));
        }
        return e;
    },
    bi = co();
var fo = 50,
    xi = () => ({
        current: 0,
        offset: [],
        progress: 0,
        scrollLength: 0,
        targetOffset: 0,
        targetLength: 0,
        containerLength: 0,
        velocity: 0,
    }),
    Ei = () => ({ time: 0, x: xi(), y: xi() }),
    uo = { x: { length: "Width", position: "Left" }, y: { length: "Height", position: "Top" } };
function wi(t, e, r, i) {
    let n = r[e],
        { length: s, position: o } = uo[e],
        a = n.current,
        l = r.time;
    (n.current = t[`scroll${o}`]),
        (n.scrollLength = t[`scroll${s}`] - t[`client${s}`]),
        (n.offset.length = 0),
        (n.offset[0] = 0),
        (n.offset[1] = n.scrollLength),
        (n.progress = Y(0, n.scrollLength, n.current));
    let c = i - l;
    n.velocity = c > fo ? 0 : Ae(n.current - a, c);
}
function Si(t, e, r) {
    wi(t, "x", e, r), wi(t, "y", e, r), (e.time = r);
}
function Ti(t, e) {
    let r = { x: 0, y: 0 },
        i = t;
    for (; i && i !== e; )
        if (Gt(i)) (r.x += i.offsetLeft), (r.y += i.offsetTop), (i = i.offsetParent);
        else if (i.tagName === "svg") {
            let n = i.getBoundingClientRect();
            i = i.parentElement;
            let s = i.getBoundingClientRect();
            (r.x += n.left - s.left), (r.y += n.top - s.top);
        } else if (i instanceof SVGGraphicsElement) {
            let { x: n, y: s } = i.getBBox();
            (r.x += n), (r.y += s);
            let o = null,
                a = i.parentNode;
            for (; !o; ) a.tagName === "svg" && (o = a), (a = i.parentNode);
            i = o;
        } else break;
    return r;
}
var vt = { start: 0, center: 0.5, end: 1 };
function qt(t, e, r = 0) {
    let i = 0;
    if ((t in vt && (t = vt[t]), typeof t == "string")) {
        let n = parseFloat(t);
        t.endsWith("px")
            ? (i = n)
            : t.endsWith("%")
              ? (t = n / 100)
              : t.endsWith("vw")
                ? (i = (n / 100) * document.documentElement.clientWidth)
                : t.endsWith("vh")
                  ? (i = (n / 100) * document.documentElement.clientHeight)
                  : (t = n);
    }
    return typeof t == "number" && (i = e * t), r + i;
}
var po = [0, 0];
function Ai(t, e, r, i) {
    let n = Array.isArray(t) ? t : po,
        s = 0,
        o = 0;
    return (
        typeof t == "number"
            ? (n = [t, t])
            : typeof t == "string" &&
              ((t = t.trim()), t.includes(" ") ? (n = t.split(" ")) : (n = [t, vt[t] ? t : "0"])),
        (s = qt(n[0], r, i)),
        (o = qt(n[1], e)),
        s - o
    );
}
var Oi = {
    Enter: [
        [0, 1],
        [1, 1],
    ],
    Exit: [
        [0, 0],
        [1, 0],
    ],
    Any: [
        [1, 0],
        [0, 1],
    ],
    All: [
        [0, 0],
        [1, 1],
    ],
};
var mo = { x: 0, y: 0 };
function ho(t) {
    return "getBBox" in t && t.tagName !== "svg" ? t.getBBox() : { width: t.clientWidth, height: t.clientHeight };
}
function Ii(t, e, r) {
    let { offset: i = Oi.All } = r,
        { target: n = t, axis: s = "y" } = r,
        o = s === "y" ? "height" : "width",
        a = n !== t ? Ti(n, t) : mo,
        l = n === t ? { width: t.scrollWidth, height: t.scrollHeight } : ho(n),
        c = { width: t.clientWidth, height: t.clientHeight };
    e[s].offset.length = 0;
    let m = !e[s].interpolate,
        u = i.length;
    for (let d = 0; d < u; d++) {
        let g = Ai(i[d], c[o], l[o], a[s]);
        !m && g !== e[s].interpolatorOffsets[d] && (m = !0), (e[s].offset[d] = g);
    }
    m && ((e[s].interpolate = Lt(e[s].offset, Le(i), { clamp: !1 })), (e[s].interpolatorOffsets = [...e[s].offset])),
        (e[s].progress = z(0, 1, e[s].interpolate(e[s].current)));
}
function go(t, e = t, r) {
    if (((r.x.targetOffset = 0), (r.y.targetOffset = 0), e !== t)) {
        let i = e;
        for (; i && i !== t; )
            (r.x.targetOffset += i.offsetLeft), (r.y.targetOffset += i.offsetTop), (i = i.offsetParent);
    }
    (r.x.targetLength = e === t ? e.scrollWidth : e.clientWidth),
        (r.y.targetLength = e === t ? e.scrollHeight : e.clientHeight),
        (r.x.containerLength = t.clientWidth),
        (r.y.containerLength = t.clientHeight);
}
function Di(t, e, r, i = {}) {
    return {
        measure: (n) => {
            go(t, i.target, r), Si(t, r, n), (i.offset || i.target) && Ii(t, r, i);
        },
        notify: () => e(r),
    };
}
var Be = new WeakMap(),
    Fi = new WeakMap(),
    Ut = new WeakMap(),
    Mi = (t) => (t === document.scrollingElement ? window : t);
function yt(t, { container: e = document.scrollingElement, ...r } = {}) {
    if (!e) return V;
    let i = Ut.get(e);
    i || ((i = new Set()), Ut.set(e, i));
    let n = Ei(),
        s = Di(e, t, n, r);
    if ((i.add(s), !Be.has(e))) {
        let a = () => {
                for (let u of i) u.measure(Ot.timestamp);
                ne.preUpdate(l);
            },
            l = () => {
                for (let u of i) u.notify();
            },
            c = () => ne.read(a);
        Be.set(e, c);
        let m = Mi(e);
        window.addEventListener("resize", c, { passive: !0 }),
            e !== document.documentElement && Fi.set(e, $t(e, c)),
            m.addEventListener("scroll", c, { passive: !0 }),
            c();
    }
    let o = Be.get(e);
    return (
        ne.read(o, !1, !0),
        () => {
            Me(o);
            let a = Ut.get(e);
            if (!a || (a.delete(s), a.size)) return;
            let l = Be.get(e);
            Be.delete(e),
                l && (Mi(e).removeEventListener("scroll", l), Fi.get(e)?.(), window.removeEventListener("resize", l));
        }
    );
}
var Ni = new Map();
function vo(t) {
    let e = { value: 0 },
        r = yt((i) => {
            e.value = i[t.axis].progress * 100;
        }, t);
    return { currentTime: e, cancel: r };
}
function bt({ source: t, container: e, ...r }) {
    let { axis: i } = r;
    t && (e = t);
    let n = Ni.get(e) ?? new Map();
    Ni.set(e, n);
    let s = r.target ?? "self",
        o = n.get(s) ?? {},
        a = i + (r.offset ?? []).join(",");
    return (
        o[a] || (o[a] = !r.target && Pe() ? new ScrollTimeline({ source: e, axis: i }) : vo({ container: e, ...r })),
        o[a]
    );
}
function Ci(t, e) {
    let r = bt(e);
    return t.attachTimeline({
        timeline: e.target ? void 0 : r,
        observe: (i) => (
            i.pause(),
            ze((n) => {
                i.time = i.iterationDuration * n;
            }, r)
        ),
    });
}
function yo(t) {
    return t.length === 2;
}
function Ri(t, e) {
    return yo(t)
        ? yt((r) => {
              t(r[e.axis].progress, r);
          }, e)
        : ze(t, bt(e));
}
function Q(t) {
    (this.listenerMap = [{}, {}]),
        t && this.root(t),
        (this.handle = Q.prototype.handle.bind(this)),
        (this._removedListeners = []);
}
Q.prototype.root = function (t) {
    let e = this.listenerMap,
        r;
    if (this.rootElement) {
        for (r in e[1]) e[1].hasOwnProperty(r) && this.rootElement.removeEventListener(r, this.handle, !0);
        for (r in e[0]) e[0].hasOwnProperty(r) && this.rootElement.removeEventListener(r, this.handle, !1);
    }
    if (!t || !t.addEventListener) return this.rootElement && delete this.rootElement, this;
    this.rootElement = t;
    for (r in e[1]) e[1].hasOwnProperty(r) && this.rootElement.addEventListener(r, this.handle, !0);
    for (r in e[0]) e[0].hasOwnProperty(r) && this.rootElement.addEventListener(r, this.handle, !1);
    return this;
};
Q.prototype.captureForType = function (t) {
    return ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(t) !== -1;
};
Q.prototype.on = function (t, e, r, i) {
    let n, s, o, a;
    if (!t) throw new TypeError("Invalid event type: " + t);
    if (
        (typeof e == "function" && ((i = r), (r = e), (e = null)),
        i === void 0 && (i = this.captureForType(t)),
        typeof r != "function")
    )
        throw new TypeError("Handler must be a type of Function");
    return (
        (n = this.rootElement),
        (s = this.listenerMap[i ? 1 : 0]),
        s[t] || (n && n.addEventListener(t, this.handle, i), (s[t] = [])),
        e
            ? /^[a-z]+$/i.test(e)
                ? ((a = e), (o = xo))
                : /^#[a-z0-9\-_]+$/i.test(e)
                  ? ((a = e.slice(1)), (o = Eo))
                  : ((a = e), (o = Element.prototype.matches))
            : ((a = null), (o = wo.bind(this))),
        s[t].push({ selector: e, handler: r, matcher: o, matcherParam: a }),
        this
    );
};
Q.prototype.off = function (t, e, r, i) {
    let n, s, o, a, l;
    if ((typeof e == "function" && ((i = r), (r = e), (e = null)), i === void 0))
        return this.off(t, e, r, !0), this.off(t, e, r, !1), this;
    if (((o = this.listenerMap[i ? 1 : 0]), !t)) {
        for (l in o) o.hasOwnProperty(l) && this.off(l, e, r);
        return this;
    }
    if (((a = o[t]), !a || !a.length)) return this;
    for (n = a.length - 1; n >= 0; n--)
        (s = a[n]),
            (!e || e === s.selector) && (!r || r === s.handler) && (this._removedListeners.push(s), a.splice(n, 1));
    return a.length || (delete o[t], this.rootElement && this.rootElement.removeEventListener(t, this.handle, i)), this;
};
Q.prototype.handle = function (t) {
    let e,
        r,
        i = t.type,
        n,
        s,
        o,
        a,
        l = [],
        c,
        m = "ftLabsDelegateIgnore";
    if (t[m] === !0) return;
    switch (
        ((c = t.target),
        c.nodeType === 3 && (c = c.parentNode),
        c.correspondingUseElement && (c = c.correspondingUseElement),
        (n = this.rootElement),
        (s = t.eventPhase || (t.target !== t.currentTarget ? 3 : 2)),
        s)
    ) {
        case 1:
            l = this.listenerMap[1][i];
            break;
        case 2:
            this.listenerMap[0] && this.listenerMap[0][i] && (l = l.concat(this.listenerMap[0][i])),
                this.listenerMap[1] && this.listenerMap[1][i] && (l = l.concat(this.listenerMap[1][i]));
            break;
        case 3:
            l = this.listenerMap[0][i];
            break;
    }
    let u = [];
    for (r = l.length; c && r; ) {
        for (e = 0; e < r && ((o = l[e]), !!o); e++)
            c.tagName &&
            ["button", "input", "select", "textarea"].indexOf(c.tagName.toLowerCase()) > -1 &&
            c.hasAttribute("disabled")
                ? (u = [])
                : o.matcher.call(c, o.matcherParam, c) && u.push([t, c, o]);
        if (c === n || ((r = l.length), (c = c.parentElement || c.parentNode), c instanceof HTMLDocument)) break;
    }
    let d;
    for (e = 0; e < u.length; e++)
        if (!(this._removedListeners.indexOf(u[e][2]) > -1) && ((a = this.fire.apply(this, u[e])), a === !1)) {
            (u[e][0][m] = !0), u[e][0].preventDefault(), (d = !1);
            break;
        }
    return d;
};
Q.prototype.fire = function (t, e, r) {
    return r.handler.call(e, t, e);
};
function xo(t, e) {
    return t.toLowerCase() === e.tagName.toLowerCase();
}
function wo(t, e) {
    return this.rootElement === window
        ? e === document || e === document.documentElement || e === window
        : this.rootElement === e;
}
function Eo(t, e) {
    return t === e.id;
}
Q.prototype.destroy = function () {
    this.off(), this.root();
};
var So = Q;
function We(t, e, r) {
    let i = document.createElement(e);
    return t && (i.className = t), r && r.appendChild(i), i;
}
function To(t, e, r) {
    let i = `translate3d(${t}px,${e || 0}px,0)`;
    return r !== void 0 && (i += ` scale3d(${r},${r},1)`), i;
}
function Zt(t, e, r) {
    (t.style.width = typeof e == "number" ? `${e}px` : e), (t.style.height = typeof r == "number" ? `${r}px` : r);
}
var G = { IDLE: "idle", LOADING: "loading", LOADED: "loaded", ERROR: "error" };
function Ao(t) {
    return ("button" in t && t.button === 1) || t.ctrlKey || t.metaKey || t.altKey || t.shiftKey;
};



export {
    So as Delegate,
    // gr as FocusTrap,
    // bi as animate,
    yi as animateSequence
    // ne as frame,
    // Li as inView,
    // ki as scroll,
    // at as spring,
    // li as stagger,
};




import { animateSequence as animateSequence15, Delegate as Delegate10 } from "vendor";
var Timeline = class extends HTMLElement {
  #delegate = new Delegate10(this);
  connectedCallback() {
    this.#delegate.on("click", '.timeline__nav button[aria-current="false"]', (event, target) => this.select({ blockId: target.dataset.blockId }));
    this.addEventListener("shopify:block:select", (event) => this.select({ blockId: event.detail.blockId, instant: event.detail.load }));
  }
  disconnectedCallback() {
    this.#delegate.off();
  }
  async select({ blockId, instant = false } = {}) {
    const fromPicture = this.querySelector(".timeline__image.is-selected");
    const toPicture = this.querySelector(`.timeline__image[data-block-id="${blockId}"]`);
    const fromContent = this.querySelector(".timeline__content.is-selected");
    const toContent = this.querySelector(`.timeline__content[data-block-id="${blockId}"]`);
    if (toPicture && fromPicture !== toPicture) {
      fromPicture.classList.remove("is-selected");
      toPicture.classList.add("is-selected");
    }
    this.querySelectorAll(".timeline__nav button").forEach((button) => {
      const isCurrent = button.dataset.blockId === blockId;
      button.setAttribute("aria-current", isCurrent ? "true" : "false");
      if (isCurrent && (button.offsetParent.scrollWidth !== button.offsetParent.clientWidth || button.offsetParent.scrollHeight !== button.offsetParent.clientHeight)) {
        button.offsetParent.scrollTo({
          left: button.offsetLeft - button.offsetParent.clientWidth / 2 + button.clientWidth / 2,
          top: button.offsetTop - button.offsetParent.clientHeight / 2 + button.clientHeight / 2,
          behavior: "smooth"
        });
      }
    });
    fromContent.classList.remove("is-selected");
    toContent.classList.add("is-selected");
    const timelineSteps = [];
    if (toPicture && fromPicture !== toPicture) {
      fromPicture.classList.remove("is-selected");
      toPicture.classList.add("is-selected");
      timelineSteps.push(
        [fromPicture, { visibility: ["visible", "hidden"], opacity: [1, 0], transform: ["scale(1)", "scale(1.05)"] }, { duration: 0.5, delay: 0.2, ease: [0.4, 0, 0.2, 1] }],
        [toPicture, { visibility: ["hidden", "visible"], opacity: [0, 1], transform: ["scale(1.05)", "scale(1)"] }, { duration: 0.5, at: "<", delay: 0.2, ease: [0.4, 0, 0.2, 1] }]
      );
    }
    timelineSteps.push(
      [fromContent, { visibility: ["visible", "hidden"], opacity: [1, 0], transform: ["translateY(0)", "translateY(-1em)"] }, { duration: 0.3, at: 0, ease: [0.55, 0.055, 0.675, 0.19] }],
      [toContent, { visibility: ["hidden", "visible"], opacity: [0, 1], transform: ["translateY(1em)", "translateY(0)"] }, { duration: 0.5, at: "+0.2", ease: [0.25, 0.46, 0.45, 0.94] }]
    );
    const animationControls = animateSequence15(timelineSteps);
    if (instant) {
      animationControls.complete();
    }
    await animationControls;
  }
};
if (!window.customElements.get("time-line")) {
  window.customElements.define("time-line", Timeline);
}

